import $ from 'jquery';
import _ from 'lodash';
import React from 'react';
import ReactDOM from 'react-dom';
import deparam from 'jquery-deparam';
import { getCurrentPageName } from 'common/js/helpers';
import jsonAjax from 'common/js/helpers/jsonAjax';
import PagedProducts from 'webshop/js/paged-products';
import ShoppingCartManager from 'webshop/js/shopping-cart-manager';
import { searchAgent } from 'common/js/search-agent';
import 'webshop/js/custom-spin';
import 'jquery-touchswipe';

import { calculateNotificationLocation } from 'webshop/js/product-helpers';
import NonStockWheelSearchByParams from "common/js/forms/non-stock-wheel-search-by-params";

var $form,
    $formPage,
    $overlay,
    $searchOrder,
    pagedProducts,
    type,
    stickyLimit = null,
    transitionEnds = ['transitionend', 'webkitTransitionEnd', 'oTransitionEnd', 'otransitionend', 'MSTransitionEnd'];

var scrollToTop = function () {
    const scrollTarget = $("#page-change-anchor").offset().top;
    $('html, body').animate({ scrollTop: scrollTarget }, 1000);
};

var linkFields = function (fieldNames) {
    return function (e) {
        var $form = $(e.target).parents('form'),
            text = e.target.value;

        _.each(fieldNames, function (fieldName) {
            $form.find('[name=' + fieldName + ']').val(text);
        });
    };
};

var formSubmit = function (e) {
    e.preventDefault();
    $form.find('[name=page]').val('1');
    $form.find('[name=order]').val($searchOrder.val());
    window.location.hash = $form.serialize();
};

var updateTireSizeFields = function () {
    if (window.search_name != 'tire_search')
        return;

    var $selectedSizeType = $form.find('[name=size_type]:checked'),
        sizeType = $selectedSizeType.val() || 'normal';

    if (!$selectedSizeType.length) {
        $form.find('[name=size_type][value="normal"]').prop('checked', true);
    }

    $form.find('.field-width, .field-extra_width, .field-profile, .field-extra_profile')
        .toggle(sizeType == 'normal');
    $form.find('.field-width_inch')
        .toggle(sizeType == 'inch' || sizeType == 'inch_width');
    $form.find('.field-diameter')
        .toggle(sizeType == 'inch');
    $form.find('.field-profile, .field-extra_profile')
        .toggle(sizeType == 'normal' || sizeType == 'inch_width');
};
var testTransitionEnd = function (e) {
    var i;
    for (i in transitionEnds) {
        if (transitionEnds[i] in window) {
            return true;
        }
    }
    return false;
};

var toggleAjaxWait = function (show) {
    $overlay.show();
    if (!show) {
        if (testTransitionEnd() && false) {
            $overlay.one(transitionEnds.join(' '), function () {
                $overlay.hide();
            });
        } else {
            $overlay.hide();
        }
    }
    $overlay.toggleClass('invisible', !show);
};
var getCar = function () {
    var brand = $form.find('[name=brand]').val(),
        model = $form.find('[name=model]').val(),
        details = $form.find('[name=details]').val(),
        car = { brand: brand, model: model, details: details };

    return car;
};
var renderQueryResult = function (data) {
    pagedProducts.updateCar(getCar());
    pagedProducts.update(data);
    pagedProducts.setWaiting(false);
    toggleAjaxWait(false);
};

var updateSearchForm = function (data) {
    // Assign values to form
    _.each($form.find('input, select'), function (el) {
        var $el = $(el),
            name = $el.attr('name'),
            type = $el.attr('type'),
            value,
            tempData,
            checked = false;
        if ($el.is('select') || type == 'text' || type == 'hidden') {
            if (_.has(data, name)) {
                value = data[name] || '';
                $el.val(value);
            } else if (name.substr(0, 6) == 'extra_') {
                var orgName = name.substr(6);
                var orgVal = data[orgName];
                // For example, if a width is chosen which is not found in
                // the width buttons, choose it in  the "extra_width" select
                if (orgVal && !(orgVal instanceof Array) && $form.find('[name=' + orgName + ']').filter('[value="' + orgVal + '"]').length == 0) {
                    $el.val(orgVal);
                }
            }
        } else if (type == 'checkbox' || type == 'radio') {
            value = $el.val();
            tempData = data[name];
            if (!tempData) {
                checked = false;
            } else if (tempData instanceof Array && _.contains(tempData, value)) {
                checked = true;
            } else {
                checked = tempData == value;
            }
            $el.prop('checked', checked);
        }
    });
    if (data.order) {
        $searchOrder.val(data.order);
    }
    updateTireSizeFields();
};

var updateSearchPlaceholder = function () {
    var searchBar = document.getElementById('product-search'),
        placeholder = document.getElementById('placeholder');

    if (!searchBar || !placeholder)
        return;

    placeholder.style.height = searchBar.offsetHeight + 'px';
    if (stickyLimit == null) {
        var container = document.querySelector('.container.product-search');
        stickyLimit = container.getBoundingClientRect().top + window.pageYOffset - 21;
    }
};

var onScroll = function () {
    var searchBar = document.getElementById('product-search'),
        placeholder = document.getElementById('placeholder'),
        offset = 5;

    if (stickyLimit == null) {
        updateSearchPlaceholder();
    }

    if (!searchBar || !placeholder)
        return;

    if (window.pageYOffset > stickyLimit + offset) {
        if (!searchBar.classList.contains("sticky")) {
            updateSearchPlaceholder();
            searchBar.classList.add("sticky");
            searchBar.classList.add("collapsed");
            placeholder.classList.add("show");
        }
    } else if (window.pageYOffset < stickyLimit - offset) {
        if (searchBar.classList.contains("sticky")) {
            searchBar.classList.remove("sticky");
            searchBar.classList.remove("collapsed");
            placeholder.classList.remove("show");
        }
    }
};

var toggleSearch = function () {
    var searchBar = document.getElementById('product-search');
    if (!searchBar.classList.contains("collapsed")) {
        searchBar.classList.add("collapsed");
    } else {
        searchBar.classList.remove("collapsed");
    }
}

var hashChanged = (function () {
    var initialized = false;

    return function (e, d) {
        var params;
        params = window.location.hash.substr(1);
        updateSearchForm(deparam(params));
        pagedProducts.setWaiting(true);
        toggleAjaxWait(true);
        jsonAjax({
            url: $form.data('action'),
            //data: params,
            data: $form.serialize(),
            type: 'GET',
            success: renderQueryResult
        });
    };
})();

$(window).on('hashchange', hashChanged);

$(function () {
    // Get the offset position of the navbar
    var container = document.querySelector('.container.product-search'),
        searchBar = document.getElementById('product-search');

    window.onscroll = function () {
        onScroll();

        if ($('.jGrowl-notification').length)
            calculateNotificationLocation($('.jGrowl-notification'), 'product-list');
    };

    $(window).on('resize', function () {
        stickyLimit = null;
        updateSearchPlaceholder();
        onScroll();
    });

    $('#toggle-search').on('click', toggleSearch)

    $('.custom-spin').customspin();
    var $menu = $('.menu-left'),
        $handle = $('.menu-mobile-handle');

    $form = $('#main-search');
    $form.submit(formSubmit);
    $form.find('input[name^="text_search"]').change(linkFields([
        'text_search', 'text_search_mobile'
    ]));
    $form.find('[name=size_type]').change(function () {
        updateTireSizeFields();
        updateSearchPlaceholder();
    });
    updateTireSizeFields();
    updateSearchPlaceholder();
    $form.find('input, select').change(formSubmit);
    $formPage = $('#id_page');
    $overlay = $('.overlay');
    type = $form.data('type');
    $searchOrder = $('.search-order-container [name=search-order]');
    $searchOrder.change(formSubmit);

    $(document).on('click', '.pagination a', scrollToTop);

    ShoppingCartManager.ShoppingCartManager.setData(window.initial_cart_data);

    var page = window.location.pathname.split('/')[1],
        productType = getCurrentPageName();

    pagedProducts = ReactDOM.render(
        <PagedProducts type={type} car={getCar()} page={page} productType={productType} />,
        document.getElementById('product-list-container')
    );

    ReactDOM.render(<ShoppingCartManager.NavShoppingCart />,
        document.getElementById('nav-cart'));

    searchAgent('search-agent', type == 'wheel' ? 'wheels' : 'tires');

    if (window.location.hash && window.location.hash !== '#') {
        hashChanged();
    } else {
        const tireTypes = {
            'kesarenkaat': 'summer',
            'nastarenkaat': 'studded',
            'kitkarenkaat': 'friction',
            'kilparenkaat': 'race',
        },
            wheelTypes = {
                'alumiinivanteet': 'alloy',
                'peltivanteet': 'sheet',
            },
            pathParam = document.location.pathname.split('/')

        if (pathParam.length === 3 || pathParam.length === 4 && !pathParam[4]) {
            if (pathParam[2].search('renkaat') !== -1) {
                $(`input[name="tire_type"][value=${tireTypes[pathParam[2]]}]`).prop('checked', true);
            } else if (pathParam[2].search('vanteet') !== -1) {
                $(`input[name="material"][value=${wheelTypes[pathParam[2]]}]`).prop('checked', true);
            }
        }
        $form.submit();
    }

    (function () {
        var orgB,
            orgHandleB;

        var initSwipe = function () {
            $handle.swipe({
                threshold: 5,
                tap: function (e, target) {
                    e.preventDefault();
                    var b,
                        min = -($menu.height() - 35),
                        orgHandleB = parseInt($handle.css('bottom').replace(/px/, ''));
                    if (orgHandleB < 55) {
                        b = 0;
                    } else {
                        b = -1 * $menu.height();
                    }
                    b = Math.min(Math.max(b, min), 0);
                    $menu.removeClass('in-transit');
                    $handle.removeClass('in-transit');
                    $menu.css('bottom', b);
                    $handle.css('bottom', $menu.height() - 25 + b);
                    $handle.toggleClass('closed', b < 0);
                },
                swipeStatus: function (e, phase, direction, distance, duration) {
                    e.preventDefault();
                    var b,
                        min = -($menu.height() - 35);
                    if (phase == 'start') {
                        $menu.addClass('in-transit');
                        $handle.addClass('in-transit');
                        orgB = parseInt($menu.css('bottom').replace(/px/, ''));
                        orgHandleB = $menu.height() - 25;
                    }
                    if (direction == 'up' || direction == 'down') {
                        // The end of swipe
                        if (phase == 'end') {
                            // If distance if long enough,
                            // go all the way
                            if (15 < distance) {
                                if (direction == 'up') {
                                    b = 0;
                                }
                                else {
                                    b = -1 * $menu.height();
                                }
                            } else {
                                // otherwise revert back to the position
                                // before swipe
                                b = orgB;
                            }
                            $menu.removeClass('in-transit');
                            $handle.removeClass('in-transit');
                        } else {
                            // track the position of the menu & handle
                            if (direction == 'up') {
                                b = orgB + distance;
                            } else if (direction == 'down') {
                                b = orgB - distance;
                            }
                        }

                        b = Math.min(Math.max(b, min), 0);
                        $menu.css('bottom', b);
                        $handle.css('bottom', $menu.height() - 25 + b);

                        if (phase == 'end') {
                            $handle.toggleClass('closed', b < 0);
                        }

                    }
                }
            });
        };

        var handleClick = function (e) {
            e.preventDefault();
            var b,
                min = -($menu.height() - 35),
                orgHandleB = parseInt($handle.css('bottom').replace(/px/, ''));
            if (orgHandleB < 55) {
                b = 0;
            } else {
                b = -1 * $menu.height();
            }
            b = Math.min(Math.max(b, min), 0);
            $menu.css('bottom', b);
            $handle.css('bottom', $menu.height() - 25 + b);
            $handle.toggleClass('closed', b < 0);
        };

        if ('ontouchstart' in window && !window.navigator.msPointerEnabled) {
            initSwipe();
        } else {
            $handle.on('click', handleClick);
        }
    })();


    var field_names = {
        desktop: ["pcd", "size", "width", "extra_pcd", "extra_size", "extra_width"],
        mobile:  ["pcd", "extra_pcd", "size", "extra_size", "width", "extra_width"],
        amount: 6
    },
    current_order = "desktop";

    var reorder_per_list = function(_list) {
        var selector_for_pivot = "#main-search >ul >li:nth-child(" + (field_names.amount+1) + ")";
        var pivot_elem = $(selector_for_pivot);
        for(var name of field_names[_list]) {
            var full_name = "field-" + name;
            var detach_name = '#main-search [class="' + full_name + '"]';
            var detached = $(detach_name).detach();
            $(detached).insertBefore( $(pivot_elem) );
        }
        current_order = _list;
    }

    var maybe_reorder = function() {
        var form_lis = $.find("#main-search [class^='field-'");
        var min_y = 0, elems_on_top_row = 0;
        $(form_lis).each(function(index, el) {
            if(index === 0) {
                min_y = el.getBoundingClientRect().y;
            }
            else {
                if( el.getBoundingClientRect().y > min_y) {
                    elems_on_top_row = index;
                    return false;
                }
            }
        });
        if(elems_on_top_row < 3  && current_order === "desktop") { reorder_per_list("mobile");  }
        if(elems_on_top_row >= 3 && current_order === "mobile")  { reorder_per_list("desktop"); }
    }

    if(window.search_name === 'nonstock_wheel_search_by_params') {
        (function() {
            var form_elem = $form.get(0);
            form_elem['no-selectize'] = true;
            NonStockWheelSearchByParams(form_elem);
        })();

        window.addEventListener('load', maybe_reorder);
        window.addEventListener('resize', maybe_reorder);
    }

    $('#mirrored-search-link').on('click', (e) => {
        // Add selected wheel sizes to the link hash before navigation

        let wheelSizes = window.location.hash
            .split('&')
            .filter(param => param.includes('wheel_size'));

        if (wheelSizes.length === 0) return true;

        const href = $(e.target).attr('href');
        $(e.target).attr(
            'href',
            href + '#' + wheelSizes.map(s => s.replace('#', '')).join('&')
        );
        return true;
    });
});



/** WEBPACK FOOTER **
 ** /home/rengasturku/nettivanne/nettivanne.git/nettivanne/static/nettivanne/webshop/js/product-search.js
 **/